var checkout = {
	init: function () {
		checkout.cards.init();
		checkout.deliveryDates.init();
		checkout.browserInfo.init();
	},

	cards: {
		amex: ['34', '37'],
		electron: ['4026', '4405', '4508', '4844', '4913', '4917', '417500'],
		visa: ['4'],
		maestro: ['5018', '5020', '5038', '5612', '5893', '6304', '6759', '6761', '6762', '6763', '6390', '0604'],
		mastercard: ['50', '51', '52', '53', '54', '55'],

		init: function () {

			$('#jsPaymentCardType:not(.js-cards-done)')
				.each(function () {
					var group = $(this);
					var select = group.find('select');
					var number = $('#jsPaymentCardNumber input');
					var maestro = $('#jsPaymentStartDate,#jsPaymentIssueNumber');
					var form = group.closest('form');

					function _check(guess) {
						if (number.val() === '') {
							// no card value
							select.val('');
							group.hide();
							maestro.hide();
						} else if (guess === '' || select.find('option[value="' + guess + '"]').length < 1) {
							// uknown card type
							select.val('');
							group.show();
							maestro.show();
						} else if (guess == 'MAESTRO') {
							// maestro card type
							select.val(guess);
							group.hide();
							maestro.show();
						} else {
							// known card type
							select.val(guess);
							group.hide();
							maestro.hide();
						}
						select.trigger('change');
					}

					function _guessCardType() {
						if (number.length === 0) return;
						var val = $.trim(number.val().replace(' ', ''));
						var guess = '';
						// guess card type
						if ($.inArray(val.substr(0, 2), checkout.cards.amex) > -1) {
							// amex
							guess = 'AMEX';
						} else if ($.inArray(val.substr(0, 4), checkout.cards.electron) > -1 ||
							$.inArray(val.substr(0, 6), checkout.cards.electron) > -1) {
							// electron
							guess = 'UKE';
						} else if ($.inArray(val.substr(0, 1), checkout.cards.visa) > -1) {
							// visa
							guess = 'VISA';
						} else if ($.inArray(val.substr(0, 4), checkout.cards.maestro) > -1) {
							// maestro
							guess = 'MAESTRO';
						} else if ($.inArray(val.substr(0, 2), checkout.cards.mastercard) > -1) {
							// mastercard
							guess = 'MC';
						}
						// run check
						_check(guess);
					}

					// startup
					_guessCardType();

					// number change
					number.on('keyup paste', _guessCardType);

					// form
					form.submit(_guessCardType);

					// done
					group.addClass('js-cards-done');
				});

		}

	},

	deliveryDates: {
		init: function () {
			$('#jsDeliveryMethod:not(.js-deliverymethod-done)').each(function () {
				var dropdown = $(this);

				function _swapDeliveryOptionsAndUpdateOrderSummary() {
					_swapDeliveryOptions();
					_updateOrderSummary();
				}

				function _swapDeliveryOptions() {
					var selected = $('#jsDeliveryMethod option:selected');
					var value = selected.val();
					var deliveryOptionsHtml = $('#deliveryOptionsTemplate').html();
					var deliveryOptionsTemplate = Hogan.compile(deliveryOptionsHtml);

					var allDeliveryOptions = JSON.parse($('#deliveryOptions').html());

					var deliveryOptions = allDeliveryOptions[value];

					$('#jsDeliveryDatesReplace').html(deliveryOptionsTemplate.render({ DeliveryDates: deliveryOptions }));
				}

				function _updateOrderSummary() {
					var selected = $("#jsDeliveryMethod option:selected");
					var price = selected.attr("data-price-text");
					var subtotal = selected.attr("data-subtotal-text");

					$("#js-delivery-total").html(price);
					$("#js-total").html(subtotal);
				}

				dropdown.on('change', _swapDeliveryOptionsAndUpdateOrderSummary);

				_swapDeliveryOptions();

				dropdown.addClass('js-deliverymethod-done');
			});
		},
	},

	browserInfo: {
		init: function () {
			var jsEnabledInput = $('input[data-browser-info="JavascriptEnabled"]');

			if (!jsEnabledInput) {
				return;
			}

			jsEnabledInput.val("True");
			$('input[data-browser-info="JavaEnabled"]').val(navigator.javaEnabled ? "True" : "False");
			$('input[data-browser-info="ColorDepth"]').val(checkout.browserInfo.colorDepth());
			$('input[data-browser-info="ScreenHeight"]').val(screen.height);
			$('input[data-browser-info="ScreenWidth"]').val(screen.width);
			$('input[data-browser-info="TimeZoneOffset"]').val(new Date().getTimezoneOffset());
			$('input[data-browser-info="Language"]').val(navigator.language);
		},

		colorDepth: function () {

			var defaultColorDepth = 24;

			if (!screen) {
				return defaultColorDepth;
			}

			var colorDepth = screen.colorDepth;

			if (!colorDepth) {
				return defaultColorDepth;
			}

			//OPAYO: This validation is required by the card schemes and not Opayo. We advise that the merchant sends these values as per the protocol 4.00 guide with a supported value. 30 bits is not a supported value. We therefore recommend sending another supported value e.g. 24 or 32 in this cases regardless of what the browser is passing to avoid the error.
			var validValues = [1, 4, 8, 15, 16, 24, 32, 48];

			if (validValues.indexOf(colorDepth) === -1) {
				for (i = validValues.length - 1; i >= 0; i--) {
					if (validValues[i] < colorDepth) {
						return validValues[i];
					}
				}
			}

			return colorDepth;
		}

	}
};

$(function () {
	checkout.init();
});